import React, { Component, createRef } from "react";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import moment from "moment";
import * as XLSX from "xlsx";
import { hover } from "@testing-library/user-event/dist/hover.js";
import { FinancealYearStartDateEndDate } from "../../utils/FinancialYearStartDateEndDate.js";
import { printFunction } from "../../components/print/printTemplate.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";


class StockLedgerAndStatement extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.inventoryServices = new InventoryServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      isGridView: true,
      partyDropdownList: [],
      rawMaterialList: [],
      pmCategoryListing: [],
      packingMaterialDropDownList: [],
      rmCategoryListing: [],
      statementForPurchaseItemList: [],
      totalCount: 0,
      stockTotalAmount: 0,
      totalQty: 0,
      totalIssue: 0,
      totalStock: 0,
      statementCompanyName: "",
      itemUOM: "",
      tableStatus: "",
      filterDetails: {
        packageMaterialId: "",
        rawMaterialId: "",
        endingDate: "",
        categoryId: "",
        categoryName: "",
        materialType: "Raw Material",
      },
      itemsForStockLedgerList: [],
      typeList: [
        { material: "Raw Material" },
        { material: "Packing Material" },
      ],
      validationRules: {
        endingDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "ending date"
            ),
          },
        ],
        materialType: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "material type"
            ),
          },
        ]
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    let dates = FinancealYearStartDateEndDate()
    let filterDetails = this.state.filterDetails
    filterDetails.endingDate = dates.endDate
    this.setState({ filterDetails: filterDetails })
    this.getAllRMDropdown();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }
  getAllRMDropdown = () => {
    this.commonServices.getAllRMDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.rmName,
          value: item._id,
          uom: item.rmUOM
        }));
        this.setState({ rawMaterialList: dropdownItems }, () => {
          this.getAllPackingMaterialDropdown()
        });
      } else {
        this.getAllPackingMaterialDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };
  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
          uom: item.pmUOM
        }));
        this.setState({ packingMaterialDropDownList: dropdownItems }, () => {
          this.getAllRMCategory()
        });
      } else {
        this.SwalServices.Error(response.Message);
        this.getAllRMCategory()
      }
    });
  };
  getAllRMCategory = () => {
    this.commonServices.getAllRMCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.rmCategory,
          value: item._id,
        }));
        this.setState({ rmCategoryListing: dropdownItems }, () => {
          this.getAllPMCategory();
        });
      } else {
        this.getAllPMCategory();
      }
    });
  };

  getAllPMCategory = () => {
    this.commonServices.getAllPMCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmCategory,
          value: item._id,
        }));
        this.setState({ pmCategoryListing: dropdownItems });
      } else {
      }
    });
  };

  openGridView = () => {
    this.setState({ isGridView: true });
  };



  resetForm = () => {
    let validState = this.state.validState
    validState.isValid = true
    validState.error = {}
    let filterDetails = this.state.filterDetails
    filterDetails.packageMaterialId = ""
    filterDetails.rawMaterialId = ""
    // filterDetails.endingDate = ""
    filterDetails.categoryId = ""
    filterDetails.categoryName = ""
    filterDetails.materialType = "Raw Material"
    this.setState({ filterDetails: filterDetails, validState: validState, stockTotalAmount: "0", itemsForStockLedgerList: [], tableStatus: "", totalCount: 0 })
  }

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.filterDetails;
    details[name] = value;
    this.setState({ filterDetails: details })

  };

  handleDropdownChange = (e, name) => {
    const value = e.target.value;
    let details = this.state.filterDetails;
    details[name] = value;
    this.setState({ filterDetails: details });
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.filterDetails;
    details[drpIdentity] = selected.value;
    if (drpIdentity === 'categoryId') {
      details.categoryName = selected.label;
    }
    details.uom = selected.uom;
    this.setState({ filterDetails: details });
  };

  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.filterDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  getAllItemsForStockLedgerReport = () => {
    let isAllFieldsValidate = this.isAllFieldsValidate();
    if (isAllFieldsValidate) {
      this.setState({ tableStatus: "Loading..." })
      let request = this.state.filterDetails;
      this.inventoryServices
        .getAllItemsForStockLedgerReport(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            if (response.responseData.length === 0) {
              this.setState({ tableStatus: "No Record Found" })
            } else {
              this.setState({ tableStatus: "" })
            }
            let details = response.responseData;
            details = details.filter(x => x.qty > 0) 
            const totalCount = details.length;
            if (totalCount === 0) {
              this.setState({ noItemFound: "No Item Found" })
            }
            const totalAmount = details.reduce(
              (sum, item) => sum + (item.totalAmount || 0),
              0
            );

            this.setState({
              itemsForStockLedgerList:
                details.length > 0 ? details : [],
              totalCount: totalCount,
              stockTotalAmount: totalAmount.toFixed(2),
            });

          } else {
            this.setState({ tableStatus: "" })
            this.SwalServices.Error(response.Message);
          }
        });
    }
  };

  getAllStatementForPurchaseItemByItemId = (item, materialType, itemName, uom) => {
    let request = {
      item: item,
      materialType: materialType,
    };
    this.inventoryServices.getAllStatementForPurchaseItemByItemId(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;
        this.setState({
          statementForPurchaseItemList: details.records,
          totalQty: details.totalQty,
          totalIssue: details.totalIssue,
          totalStock: details.totalStock,
          statementCompanyName: details.materialName,
          itemUOM: uom
        }, () => {
          this.isAllFieldsValidate();
          this.setState({ isGridView: false });
        }
        );
      }
    });
  };

  render() {
    return (
      <div className="stockLedgerAndStatement-page reports-page">

        {/* Fisrt page  */}
        {this.state.isGridView === true ? (
          <>
            <div className="item-search !mb-[10px]">
              <div className="item-inner-grp flex gap-2.5 mb-3.5">
                <div className="start-date w-full">
                  <label>Ending Date</label>
                  <input
                    className={` inputFocus ${this.state.validState?.error?.endingDate ? "errorInput" : ""}`}
                    type="date"
                    id="endingDate"
                    name="endingDate"
                    value={this.state.filterDetails.endingDate}
                    onChange={(event) => this.handleChange(event, "endingDate")}
                    style={{ width: "100%" }}
                    disabled={this.state.itemsForStockLedgerList.length > 0 ? true : false}
                  />
                  {/* <ValidationText
                    error={this.state.validState.error.endingDate}
                  /> */}
                </div>
                <div className="material-selector w-full">
                  <label>Material Type</label>
                  <select
                    value={this.state.filterDetails.materialType}
                    disabled={this.state.itemsForStockLedgerList.length > 0 ? true : false}
                    onChange={(e) =>
                      this.handleDropdownChange(
                        e,
                        "materialType",
                        "FilterDetails"
                      )
                    }
                  >

                    {this.state.typeList.map((x, key) => (
                      <option key={key} value={x.material}>
                        {x.material}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="material-dropdown min-w-[30%]">
                  <label>Material Name</label>
                  {this.state.filterDetails.materialType === 'Raw Material' ?
                    <>
                      <MultiSelectDropdown
                        drpIdentity="rawMaterialId"
                        options={this.state.rawMaterialList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                          this.setFilterParameters(selected, "rawMaterialId")
                        }
                        allowSelectAll={false}
                        value={this.state.rawMaterialList.filter(
                          (party) =>
                            party.value === this.state.filterDetails.rawMaterialId
                        )}
                      />
                    </>
                    : this.state.filterDetails.materialType === 'Packing Material' ?
                      <>
                        <MultiSelectDropdown
                          drpIdentity="packageMaterialId"
                          options={this.state.packingMaterialDropDownList}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={(selected) =>
                            this.setFilterParameters(selected, "packageMaterialId")
                          }
                          allowSelectAll={false}
                          value={this.state.packingMaterialDropDownList.filter(
                            (party) =>
                              party.value === this.state.filterDetails.packageMaterialId
                          )}
                        />
                      </>
                      :
                      null
                  }
                </div>
                <div className="end-date w-full">
                  <label>Category</label>
                  {this.state.filterDetails.materialType === "Raw Material" ? (
                    <MultiSelectDropdown
                      drpIdentity="categoryId"
                      options={this.state.rmCategoryListing}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={true}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "categoryId")
                      }
                      allowSelectAll={false}
                      value={this.state.rmCategoryListing.filter(
                        (party) =>
                          party.value === this.state.filterDetails.categoryId
                      )}
                      isDisabled={this.state.itemsForStockLedgerList.length > 0 ? true : false}
                    />
                  ) : (
                    <MultiSelectDropdown
                      drpIdentity="categoryId"
                      options={this.state.pmCategoryListing}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={true}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "categoryId")
                      }
                      allowSelectAll={false}
                      value={this.state.pmCategoryListing.filter(
                        (party) =>
                          party.value === this.state.filterDetails.categoryId
                      )}
                      isDisabled={this.state.itemsForStockLedgerList.length > 0 ? true : false}
                    />
                  )}
                </div>


                <div className="start-date w-full">
                  <label>Total Amount</label>
                  <input
                    className="w-full"
                    type="number"
                    id="grandTotal"
                    name="grandTotal"
                    autocomplete="off"
                    disabled
                    value={this.state.stockTotalAmount
                      ? this.state.stockTotalAmount
                      : 0}

                  />

                </div>

              </div>
              <div className="btn-grp ">
                <button
                  class="add-btn"
                  onClick={() => this.getAllItemsForStockLedgerReport()}
                >
                  Search
                </button>
                <button className="cancel-btn" onClick={this.resetForm}>Cancel</button>
                {/* {this.state.isAllowforPrintData &&
                  this.state.isGridView === false ? */}
                {this.state.itemsForStockLedgerList &&
                  this.state.itemsForStockLedgerList.length > 0 ? (
                  <button
                    class="print-btn"
                    onClick={() => printFunction()}
                  >
                    Print
                  </button>
                ) : null}

              </div>
            </div>
            <div className="table-upper">
              <p className="mb-[3px] text-[15px] font-medium text-[#474747]" >
                Total Count :- {this.state.totalCount ? this.state.totalCount : 0}
              </p>
            </div>
            <>
              <div class="item-listing">
                <div className="hidden print-title">
                  <h4 className="text-black font-bold leading-tight">Stock Ledger & Statement Report</h4>
                  <div>
                    <p className="text-black w-fit">Material type:- {this.state.filterDetails.materialType}</p>
                    {this.state.filterDetails.categoryName !== "" ? <p className="text-black">Category type:- {this.state.filterDetails.categoryName}</p> : null}
                  </div>
                </div>
                <div class="itemList-table">
                  <div class="table-container" style={{ height: "calc(100vh - 202px)" }} >
                    <table class="itemList">
                      <thead>
                        <tr>
                          <td className="w-[28%]">Item Name</td>
                          <td className="w-[12%]">Stock</td>
                          <td className="w-[10%]">UOM</td>
                          <td className="w-[10%]">Rate</td>
                          <td className="w-[15%]">Amount</td>
                          {/* <td style={{ width: "13%" }}>Category</td>
                          <td style={{ width: "12%" }}>Material Type</td> */}
                        </tr>
                      </thead>


                      <tbody>
                        {this.state.itemsForStockLedgerList && this.state.itemsForStockLedgerList.length > 0 ? (
                          this.state.itemsForStockLedgerList.map((details, key) => (
                            <tr
                              key={key}
                              className="hover:bg-gray-200 cursor-pointer "
                              onClick={() =>
                                this.getAllStatementForPurchaseItemByItemId(
                                  details.rawMaterialId
                                    ? details.rawMaterialId
                                    : details.packageMaterialId,
                                  details.rawMaterialId
                                    ? "Raw Material"
                                    : "Packing Material",
                                  details.rawMaterialId
                                    ? details.rawMaterialId.rmName
                                    : details.packageMaterialId.pmName,
                                  details.rawMaterialId
                                    ? details.rawMaterialId.rmUOM
                                    : details.packageMaterialId.pmUOM
                                )
                              }
                            >
                              <td>
                                {details.rawMaterialId
                                  ? details.rawMaterialId.rmName
                                  : details.packageMaterialId.pmName}
                              </td>
                              <td>{details.qty}</td>
                              <td>
                                {details.rawMaterialId
                                  ? details.rawMaterialId.rmUOM
                                  : details.packageMaterialId.pmUOM}
                              </td>
                              <td>{details.rate.toFixed(2)}</td>
                              <td>{(details.qty * details.rate).toFixed(2)}</td>
                              {/* <td>
                                {details.rawMaterialId
                                  ? details.rawMaterialId.rmCategory
                                  : details.packageMaterialId.pmCategory}
                              </td>
                              <td>{details.rawMaterialId ? "Raw" : "Packing"}</td> */}
                            </tr>
                          ))
                        ) : this.state.itemsForStockLedgerList &&
                          this.state.itemsForStockLedgerList.length === 0
                          && this.state.tableStatus !== "" ? (
                          <tr>
                            <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                              {this.state.tableStatus}
                            </td>
                          </tr>
                        ) : this.state.itemsForStockLedgerList &&
                          this.state.itemsForStockLedgerList.length === 0
                          && this.state.tableStatus === "" ? null : ""}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          </>
        ) : null}

        {this.state.isGridView === false ? (
          <>
            <div className="flex gap-2.5 mb-3.5">
              <div className="start-date w-[30%] ">
                <label>Item Name</label>
                <input
                  className="w-full"
                  type="text"
                  id="itemName"
                  name="ItemName"
                  disabled
                  value={this.state.statementCompanyName !== ""
                    ? this.state.statementCompanyName
                    : ""}
                />
              </div>
              <div className="start-date w-[10%] ">
                <label>UOM</label>
                <input
                  className="w-full"
                  type="text"
                  id="itemUOM"
                  name="itemUOM"
                  disabled
                  value={this.state.itemUOM !== ""
                    ? this.state.itemUOM
                    : ""}
                />

              </div>
              <button className="back-btn mt-auto" onClick={() => this.openGridView()}>Back</button>
            </div>
            {/* <div className="table-upper">
              <p className="mb-[3px] text-[15px] font-medium text-[#474747]" >
                Total Count :- {this.state.totalCount ? this.state.totalCount : 0}
              </p>
            </div> */}

            <div class="item-listing">
              <div class="itemList-table">
                <div className="table-container" style={{ height: "calc(100vh - 325px)" }}>
                  <table class="itemList">
                    <thead>
                      <tr>
                        <td style={{ width: "5%" }}>Ref. No</td>
                        <td style={{ width: "7%" }}>Date</td>
                        <td style={{ width: "7%" }}>Invoice No.</td>
                        <td style={{ width: "15%" }}>Party Name/ Product Name</td>
                        <td style={{ width: "5%" }}>Batch No</td>
                        <td style={{ width: "5%" }}>Receipt</td>
                        <td style={{ width: "10%" }}>Issue</td>
                      </tr>
                    </thead>
                    {this.state.statementForPurchaseItemList &&
                      this.state.statementForPurchaseItemList.length > 0 ? (
                      this.state.statementForPurchaseItemList.map(
                        (details, key) => (
                          <tbody key={key}>
                            <tr>
                              <td>
                                {details.isInwardRecord === true || details.isMonogramRecord === true || details.isAdditionalEntryRecord === true ||
                                  details.isIssuedRecord === true || details.isGSTInvoiceRecord === true ?
                                  details.refNo : ""}

                                {details.isOpeningStock === true ?
                                  '0'
                                  : ''}

                              </td>
                              <td>
                                {details.isInwardRecord === true || details.isMonogramRecord === true || details.isAdditionalEntryRecord === true ||
                                  details.isIssuedRecord === true || details.isGSTInvoiceRecord === true
                                  ? moment(details.refDate).format("DD MMM yyyy") : ""}

                                {/* {details.isOpeningStock === true ?
                                  moment(details.openingStockDate).format('DD MMM yyyy')
                                  : ''} */}


                              </td>
                              <td>
                                {details.isInwardRecord === true || details.isMonogramRecord === true || details.isAdditionalEntryRecord === true ||
                                  details.isIssuedRecord === true || details.isGSTInvoiceRecord === true
                                  ? details.invoiceNo : ""}

                                {details.isOpeningStock === true ?
                                  'Opening Stock'
                                  : ''}

                              </td>
                              <td>
                                {details.isInwardRecord === true || details.isMonogramRecord === true || details.isAdditionalEntryRecord === true ||
                                  details.isIssuedRecord === true || details.isGSTInvoiceRecord === true
                                  ? details.partyName : ""}

                                {details.isOpeningStock === true ?
                                  'Opening Stock'
                                  : ''}

                              </td>
                              <td>
                                {details.isInwardRecord === true || details.isMonogramRecord === true && details.isIssuedRecord === true || details.isAdditionalEntryRecord === true ||
                                  details.isIssuedRecord === true || details.isGSTInvoiceRecord === true ?
                                  details.batchNo
                                  : null}
                              </td>
                              <td>
                                {/* {details.isIssuedRecord === true ? ""
                                  : details.qty ? details.qty : 0.0} */}
                                {details.qty ? details.qty : ''}
                              </td>
                              <td>
                                {/* {details.isIssuedRecord === true
                                  ? details.issueQty ? details.issueQty : 0.0
                                  : details.isGSTInvoiceRecord === true
                                    ? details.qty ? details.qty : ""
                                    : ""} */}
                                {details.issueQty ? details.issueQty : ''}
                              </td>
                            </tr>
                          </tbody>
                        )
                      )
                    ) : (
                      <tbody className="validation-body">
                        <tr>
                          <td
                            colSpan={9}
                            style={{ textAlign: "center", fontSize: "16px" }}
                          >
                            No Records Found
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
              </div>
            </div>
            <div className="item-sections  min-w-[250px] max-w-[300px]  rounded-[10px] !px-3 !py-5  !bg-white mt-[15px]" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
              <p className='!text-center !text-[17px] !font-semibold'>Summary</p>
              <div className="search-grp flex gap-2">
                <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                  Total Stock
                </div>
                <input
                  className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                  type="number"
                  id="subTotal"
                  name="subTotal"
                  autocomplete="off"
                  disabled
                  value={this.state.totalQty}

                />
              </div>
              <div className="search-grp flex gap-2">
                <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                  Total Issue
                </div>
                <input
                  className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px]"
                  type="number"
                  id="crDrNote"
                  name="crDrNote"
                  autocomplete="off"
                  disabled
                  value={this.state.totalIssue}

                />
              </div>
              <div className="search-grp flex gap-2">
                <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                  Closing Balance
                </div>
                <input
                  className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px]"
                  type="number"
                  id="crDrNote"
                  name="crDrNote"
                  autocomplete="off"
                  disabled
                  value={this.state.totalStock}

                />
              </div>



            </div>
          </>

        ) : null}

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Stock Statement & Ledger</div>
                  </td>
                  <td>
                    <div className="hdr-meta">
                      Material Type: <strong>{this.state.filterDetails.materialType}</strong><br />
                      End Date: <strong>{this.state.filterDetails.endingDate}</strong>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
                              <div>
                                <span className="info-label">Item Name:</span>
                                <p className="info-value">Paracetamol</p>
                              </div>
                            </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "40%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Item Name
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Stock
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    UOM
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Rate
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.purchaseOrderReportList && this.state.purchaseOrderReportList.length > 0 ?
                  this.state.purchaseOrderReportList.map((details, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {details.rawMaterialId
                          ? details.rawMaterialId.rmName
                          : details.packageMaterialId.pmName}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.qty}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.rawMaterialId
                          ? details.rawMaterialId.rmUOM
                          : details.packageMaterialId.pmUOM}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.rate.toFixed(2)}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {(details.qty * details.rate).toFixed(2)}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

      </div >
    );
  }
}
export default StockLedgerAndStatement;
